export default __webpack_public_path__ + "static/media/OrthoPhotoMosaic.cf7ef907.jpg";